function PrivacyPolicy() {
  return (
    <>
      <section className=" cont-form">
        <div className="container px-0">
          <div className="row privacy">
            <div className="row align-items-center text-center">
              <div className="col-12 ">
                <h1>Cloudlas Apps - Privacy Policy</h1>
              </div>
            </div>

            <div className="col-sm-12 col-lg-12 priv-cont px-0">
              <p>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;This is the privacy policy
                statement of the Microsoft 365/SharePoint apps developed by
                Cloudlas Solutions LLP which are available in the Microsoft
                store or you have purchased from Cloudlas.com. We may publish
                more apps or upgrade the existing apps. Any future changes
                happening in the privacy policy statement will be notified in
                the home page of our official website and in the home page of
                the apps according to the nature and purpose of the app.{" "}
              </p>

              <p>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Microsoft 365 apps developed by
                Cloudlas solutions reside in your Microsoft 365 tenant
                application or in the Microsoft azure platform licenced to
                Cloudlas Solutions LLP. We will explicity notify, if any app is
                hosted in any servers outside the Microsoft 365 tenant. Please
                see the specifics of the privacy policy statement
              </p>

              <ul className="">
                <li>
                  We do not collect any organizational or personal information
                  of the host tenant and its users.
                </li>
                <li>
                  We do not connect your environment with any third party
                  services or apps through our apps and services.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default PrivacyPolicy;
